import { Box } from '@mui/material';
import React, { ReactNode } from 'react';
import CustomTypography from './CustomTypography';
import IconError from '../../assets/icons/IconError';

type ErrorMessageProps = {
  children: ReactNode;
};

const ErrorMessage = ({ children }: ErrorMessageProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        // flex: '1',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <IconError />
      <CustomTypography
        variant='body1'
        sx={{
          color: '#DF4C0E',
          fontFamily: 'Montserrat',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '18px',
          flex: '1',
        }}
      >
        {children}
      </CustomTypography>
    </Box>
  );
};

export default ErrorMessage;
